import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCodeFrame20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconCodeFrame20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.5 3.5h-13a1 1 0 0 0-1 1v1h15v-1a1 1 0 0 0-1-1m1 3.5h-15v8.5a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1zm-14-5A2.5 2.5 0 0 0 1 4.5v11A2.5 2.5 0 0 0 3.5 18h13a2.5 2.5 0 0 0 2.5-2.5v-11A2.5 2.5 0 0 0 16.5 2zm4.034 6.92a.75.75 0 0 1 0 1.06l-1.823 1.824 1.823 1.824a.75.75 0 0 1-1.06 1.06L4.12 12.334l-.53-.53.53-.53L6.474 8.92a.75.75 0 0 1 1.06 0m4.932 0a.75.75 0 0 0 0 1.06l1.824 1.824-1.824 1.824a.75.75 0 0 0 1.06 1.06l2.354-2.354.53-.53-.53-.53-2.354-2.354a.75.75 0 0 0-1.06 0m-.823.931a.75.75 0 1 0-1.4-.537l-1.73 4.505a.75.75 0 1 0 1.401.537z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCodeFrame20);
